import graphql__bbd333fec2483055fc04 from "./__generated__/AnswerPreviewPages_answers.graphql.js";import { isNull } from "lodash";
import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import AnswerPreview from "./";

const AnswerPreviewPages = props => {
  const answers = useFragment(AnswerPreviewPages_answers, props.answers);

  // This method builds a div for each page of the proposal form and displays
  // the answer previews for each answer of the page.
  //
  const pages = useMemo(() => {
    const pages = answers.reduce((pages, answer) => {
      const { id, position, title } = answer.formField.formPage;
      const index = isNull(position) ? id : position;

      if (!pages[index]) {
        pages[index] = { id, title, answers: [] };
      }

      pages[index].answers.push(answer);

      return pages;
    }, {});

    return Object.keys(pages)
      .sort((a, b) => a - b)
      .map(key => pages[key]);
  }, [answers]);

  return pages.map(({ id, title, answers }, index) => (
    <div key={id} className="box margin-bottom-xs padding-y-md padding-x-lg">
      <div className="margin-bottom-sm">
        <span className="text-title-section">
          {index + 1}. {title}
        </span>
      </div>

      {answers.map(answer => {
        return (
          <div key={answer.id} className="form-answer">
            <div className="form-answer-label form-label">
              {answer.formField.required && "* "}
              {answer.formField.label}
            </div>

            <div className="form-answer-data">
              <AnswerPreview answer={answer} />
            </div>
          </div>
        );
      })}
    </div>
  ));
};

const AnswerPreviewPages_answers = graphql__bbd333fec2483055fc04;

export default AnswerPreviewPages;
